import { facilityGroups, houseRules, popularFacilities } from '../data/propertyInformation';
import './property-information.css';

function ItemList({ items }) {
  return (
    <ul className="property-info__list">
      {items.map((item) => <li key={item}>{item}</li>)}
    </ul>
  );
}

function PropertyInformation() {
  return (
    <section className="property-info" aria-label="Property facilities and policies">
      <div className="property-info__inner">
        <section className="property-info__popular">
          <p className="property-info__eyebrow">THE DETAILS</p>
          <h2>Facilities of Leopard Bliss Yala</h2>
          <h3>Most popular facilities</h3>
          <div className="property-info__popular-grid">
            {popularFacilities.map((facility) => <span key={facility}>{facility}</span>)}
          </div>
        </section>

        <section className="property-info__section">
          <h2>Facilities</h2>
          <p>Comforts, services and experiences available during your stay.</p>
          <div className="property-info__groups">
            {facilityGroups.map((group) => (
              <article className="property-info__group" key={group.title}>
                <h3>{group.title}</h3>
                <ItemList items={group.items} />
              </article>
            ))}
          </div>
        </section>

        <section className="property-info__section property-info__rules">
          <h2>House rules</h2>
          <p>Leopard Bliss Yala takes special requests. Add them during the next step.</p>
          <div className="property-info__groups">
            {houseRules.map((group) => (
              <article className="property-info__group" key={group.title}>
                <h3>{group.title}</h3>
                <ItemList items={group.items} />
              </article>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
}

export default PropertyInformation;